<ng-container *ngIf="message">

    <div class="thread my-4" [ngClass]="{'right': message.user_id}">

        <!-- Thread header -->
        <div class="header p-4 xs:flex-wrap">

            <!-- Sender avatar -->
            <div class="avatar">
                <img ngxGravatar [email]="message.user && message.user.email || 'bot@getassistance.net'"/>
            </div>

            <!-- Info -->
            <div class="info">
                <!-- From -->

                <ng-container *ngIf="chat?.name || chat?.email; else bot">
                    <div class="from">{{chat.name}} {{chat.email}}</div>
                </ng-container>

                <ng-template #bot>
                    You
                </ng-template>

                <!-- To -->
                <div class="to">
                    <div class="others flex text-cool-gray-400">
                        <ng-container *ngIf="message.user">
                            <span class="email">{{message.user.email}}</span>
                        </ng-container>
                        <div class="bg-gray-400 h-1 m-2 rounded-full w-1"></div>
                        <span class="created">{{_tableUtilsService.getTimeAgo(message.created_at)}}</span>
                    </div>

                </div>

            </div>

        </div>

        <!-- Content -->
        <div class="content p-4"
             [innerHTML]="message.text">
        </div>

        <!-- Attachments -->
        <app-view-attachments class="p-4"
                              [currentAttachments]="message.attachments"
                              [showDelete]="false">
        </app-view-attachments>
    </div>
</ng-container>
